import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-class-subject-wise-marks-entry',
  templateUrl: './class-subject-wise-marks-entry.component.html',
  styleUrls: ['./class-subject-wise-marks-entry.component.css']
})
export class ClassSubjectWiseMarksEntryComponent implements OnInit {

  constructor(private examService:ExamService,private lookupService: LookupService, public globalHelper: GlobalHelper,     private spinnerService: Ng4LoadingSpinnerService) { }
 

  
  IsGradeOnly = false;

  ClassSubjectWiseEntryModel = {
      ExamID: 0,
      ExamMapID: 0,
      ExamTypeID: 0,
      BranchID: 0,
      ClassID: 0,
      SectionID: 0,
      SessionID: 0,
      StreamID: 0,
      CourseID: 0,
      Course:"",
      ClassSectionID:"",
      TermID:0,

  }
  sortingOrder = 0;
  groupedItems = [];
  itemsPerPage = 40;
  currentPage = 0;
  query = '';
  PagingInit  () {
      this.sortingOrder = 0;
      this.groupedItems = [];
      this.itemsPerPage = 40;
      this.currentPage = 0;
      this.query = '';
  }


  
  

  
  Print  () {
      var divContents = document.getElementById("dvContainer").innerHTML;
      divContents = divContents.replace('no record found', '');
      var printWindow = window.open('', '', 'height=400,width=800');
      printWindow.document.write('<html><head><title></title>');
      printWindow.document.write('<style type="text/css">');
      printWindow.document.write('.t1{ border-top: 1px solid black;  border-left: 1px solid black;white-space:nowrap;font-family:Calibri;font-size:10px} .t2 { border-right: 1px solid black; border-bottom: 1px solid black;}.t3 { border-right: 1px solid black; border-bottom: 1px solid black;}');
      printWindow.document.write('</style>');
      printWindow.document.write('</head><body >');
      printWindow.document.write(divContents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
  }
  ExamTypeList = [];
  CourseList = [];
  
  ClasswiseMarkList = [];
  ExamMasterList = [];
  onSelect  ($item) {
      this.ClassSubjectWiseEntryModel.ClassID = $item.ClassID;
      this.ClassSubjectWiseEntryModel.SectionID = $item.SectionID
      this.ClassSubjectWiseEntryModel.ExamMapID = 0;
      this.ExamTypeList = [];
      this.CourseList = [];
      this.CourseList = [];
      this.ClasswiseMarkList = [];
      this.ExamMasterList = [];
      this.ClassSubjectWiseEntryModel.TermID = 0;
      this.GetTerm();
  }

  ClassSectionList: any;
  GetClassSection() {
      this.lookupService.GetLookupsList('STClassSection', '').subscribe((data) => {
          this.ClassSectionList = data.LookupItems;

      });
  };

  SetID() {

    this.ClasswiseMarkList = [];
    this.ClassSectionStreamList =[];
    this.ExamTypeList = [];
    this.CourseList = [];
    this.ExamMasterList = [];
    this.TermList = [];
    this.ClassSubjectWiseEntryModel.ExamTypeID = 0;
    this.ClassSubjectWiseEntryModel.CourseID = 0;
    this.ClassSubjectWiseEntryModel.ExamTypeID = 0;
    this.ClassSubjectWiseEntryModel.ExamMapID = 0;
    this.ClassSubjectWiseEntryModel.ClassID = 0;
    this.ClassSubjectWiseEntryModel.SectionID = 0;
    this.ClassSubjectWiseEntryModel.TermID = 0;
      if (this.ClassSubjectWiseEntryModel.ClassSectionID != "") {
          var strClassSectionID = this.ClassSubjectWiseEntryModel.ClassSectionID.split('-');
          this.ClassSubjectWiseEntryModel.ClassID = parseInt(strClassSectionID[0]);
          this.ClassSubjectWiseEntryModel.SectionID = parseInt(strClassSectionID[1]);
          this.GetTerm();

      }
  }
  TermList = [];
  Class = '';
  ClassSectionStreamList =[];
  GetClassSection1  () {
       this.spinnerService.show();
      this.ClasswiseMarkList = [];
      this.ClassSectionStreamList =[];
      this.ExamTypeList = [];
      this.CourseList = [];
      this.ExamMasterList = [];
      this.TermList = [];
      this.ClassSubjectWiseEntryModel.ExamTypeID = 0;
      this.ClassSubjectWiseEntryModel.CourseID = 0;
      this.ClassSubjectWiseEntryModel.ExamTypeID = 0;
      this.ClassSubjectWiseEntryModel.ExamMapID = 0;
      this.ClassSubjectWiseEntryModel.ClassID = 0;
      this.ClassSubjectWiseEntryModel.SectionID = 0;
      this.lookupService.GetLookupsList('STClassSection', '').subscribe( (data)=> {
        this.ClassSectionStreamList = data.LookupItems;
        this.ClassSectionStreamList.splice(0,1);
        this.spinnerService.hide();
    });
      
  };
  
  AcademicSessionList:any;
  GetAcademicSession  () {
       this.lookupService.GetLookupsList('AcademicSession', '').subscribe( (data)=> {
          this.AcademicSessionList = data.LookupItems;
      });
  };

  
  Clear  () {
      this.ClassSubjectWiseEntryModel.Course = '';
  }
  maxmark =0;
  Avrg =0;
  GetClassWiseSubjectMark  () {
       this.spinnerService.show();
    
      
  this.examService.GetClassWiseSubjectMark(JSON.stringify(this.ClassSubjectWiseEntryModel)).subscribe( (response)=> {
          this.ClasswiseMarkList = response.ClasswiseMarkList;
           this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(response);

          var Sum = 0;
          var total = 0;
          total = this.ClasswiseMarkList.length;
          var countstudent = 0
          if (this.ClasswiseMarkList != null && this.ClasswiseMarkList.length > 0) {
              for (var i = 0; i < this.ClasswiseMarkList.length; i++) {
                  this.maxmark = this.ClasswiseMarkList[i].MaxMarks;
                  if (this.ClasswiseMarkList[i].MarksObtained != -1 && this.ClasswiseMarkList[i].MarksObtained != -2) {
                      countstudent = countstudent + 1;
                      Sum = Sum + this.ClasswiseMarkList[i].MarksObtained
                  }
              }

              var x = this.ClasswiseMarkList;
              this.GetGradeWise(x);
          }
          this.Avrg = Sum / countstudent;
        
          // this.search1($filter('orderBy')(this.ClasswiseMarkList, this.propertyName, this.reverse));
          

      });
  };
  min = 0;
  max = 0;
  Premax = 0;
  Premin = 0;
 
  GetGradeWise  (x) {
       this.spinnerService.show();
      this.min = x[0].MarksObtained;
      this.max = x[0].MarksObtained;
      this.Premax = 0;
      this.Premin = 0;
      for (var k = 1; k < x.length; k++) {

          if (this.min > x[k].MarksObtained && x[k].MarksObtained != -1 && x[k].MarksObtained != -2) {
              this.min = x[k].MarksObtained;
              if (this.maxmark > 0)
                  this.Premin = (x[k].MarksObtained / this.maxmark) * 100;
          }

          if (this.max < x[k].MarksObtained && x[k].MarksObtained != -1 && x[k].MarksObtained != -2) {
              this.max = x[k].MarksObtained;
              if (this.maxmark > 0)
                  this.Premax = (x[k].MarksObtained / this.maxmark) * 100;
          }
      }
       this.spinnerService.hide();
  }


  SaveClassWiseSubjectMark  () {
      
       this.examService.SaveClassWiseSubjectMark(JSON.stringify(this.ClassSubjectWiseEntryModel), JSON.stringify(this.ClasswiseMarkList)).subscribe( (response)=> {
         
              this.globalHelper.CheckActionStatus(response);
         

          if (response.webResponse.Status) {
              this.GetClassWiseSubjectMark();
          }
      });
  };

  GetExamMaster  () {
       this.spinnerService.show();
      this.ClasswiseMarkList = [];
      this.ExamTypeList = [];
      this.CourseList = [];
      this.ExamMasterList = [];
      this.ClassSubjectWiseEntryModel.ExamTypeID = 0;
      this.ClassSubjectWiseEntryModel.ExamMapID = 0;
      this.ClassSubjectWiseEntryModel.CourseID = 0;
      this.ClassSubjectWiseEntryModel.TermID = this.ClassSubjectWiseEntryModel.TermID == null ? 0 : this.ClassSubjectWiseEntryModel.TermID;
      var item = {
          ItemId: this.ClassSubjectWiseEntryModel.ClassID,
          ItemId2: this.ClassSubjectWiseEntryModel.TermID,
          SessionID: this.ClassSubjectWiseEntryModel.SessionID
      }
       this.lookupService.GetLookupsList('ExamEntry', JSON.stringify(item)).subscribe( (data)=> {
          this.ExamMasterList = data.LookupItems;
           this.spinnerService.hide();

      });
  };
  Submitted:false;
  ResetChange  () {
      this.ClasswiseMarkList = [];
      if (this.CourseList != null) {
          for (var i = 0; i < this.CourseList.length; i++) {
              if (this.CourseList[i].ItemId == this.ClassSubjectWiseEntryModel.CourseID) {
                  this.IsGradeOnly = this.CourseList[i].IsGradeOnly;
                  return;
              }
          }
      }
     
  }

  GetAllExamType  () {
       this.spinnerService.show();
      this.ClasswiseMarkList = [];
      this.ExamTypeList = [];
      this.CourseList = [];
      this.ClassSubjectWiseEntryModel.ExamTypeID = 0;
       this.lookupService.GetLookupsList('ExamType', '').subscribe( (data)=> {
          this.ExamTypeList = data.LookupItems;
           this.spinnerService.hide();

      });
  };

  GetTerm  () {
       this.spinnerService.show();
      this.TermList = [];

      var ItemBo = {
          ItemId: this.ClassSubjectWiseEntryModel.ClassID
      }
       this.lookupService.GetLookupsList('ExamTerm', JSON.stringify(ItemBo)).subscribe( (data)=> {
          this.TermList = data.LookupItems;
          this.spinnerService.hide();
         
      });
  };

  GetAllCourse  () {
       this.spinnerService.show();
      this.ClasswiseMarkList = [];
      this.ClassSubjectWiseEntryModel.ExamTypeID = this.ClassSubjectWiseEntryModel.ExamTypeID == null ? 0 : this.ClassSubjectWiseEntryModel.ExamTypeID;
      this.ClassSubjectWiseEntryModel.ExamMapID = this.ClassSubjectWiseEntryModel.ExamMapID == null ? 0 : this.ClassSubjectWiseEntryModel.ExamMapID;
      var itembo = {
          'ItemId': this.ClassSubjectWiseEntryModel.ClassID,
          'ItemId1': this.ClassSubjectWiseEntryModel.SectionID,
          'ItemId2': this.ClassSubjectWiseEntryModel.ExamTypeID,
          'ItemId3': this.ClassSubjectWiseEntryModel.ExamMapID,               
         
      }
       this.lookupService.GetLookupsList('MarksEntryCourseFilter', JSON.stringify(itembo)).subscribe( (data)=> {
          this.CourseList = data.LookupItems;               
          this.ClassSubjectWiseEntryModel.CourseID = 0;
           this.spinnerService.hide();
      });
  };

  
  ngOnInit() {
    this.PagingInit();
    this.GetClassSection();
  }

}
